// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"621cde1b","279":"36e7d53b","454":"e3a1d5e9","467":"36e7d53b","515":"36e7d53b","519":"af0b9d39","565":"36e7d53b","679":"0b72b973","749":"9137311d"}[chunkId] + ".chunk.css";
};